import React, { useState } from 'react';
import BemClass from '@upsales/components/Utils/bemClass';
import { Tooltip, Text, Flex } from '@upsales/components';
import './AboutDropDown.scss';
import { useTranslation } from 'Components/Helpers/translate';
import { useFeatureAvailable } from 'App/components/hooks';
import { Feature } from 'Store/actions/FeatureHelperActions';

type Props = {
	aboutText: string;
	summary?: string;
	isSubaccount?: boolean;
	isInactive?: boolean;
	isLoading?: boolean;
};

const AboutDropDown = ({ aboutText, summary, isInactive = false, isSubaccount = false, isLoading = false }: Props) => {
	const { t } = useTranslation();
	const [expanded, setExpanded] = useState(false);
	const hasAI = useFeatureAvailable(Feature.AI);
	const showAISummary = !isLoading && hasAI && summary?.trim();
	const displayText = showAISummary ? summary : aboutText;

	if (!displayText) {
		return null;
	}

	const classes = new BemClass('AboutDropDown');

	return (
		<div
			className={classes
				.mod({
					expanded,
					isSubaccount,
					isInactive,
					hasSummary: showAISummary,
					isLoading
				})
				.b()}
			onClick={() => setExpanded(!expanded)}
		>
			<Flex
				className={showAISummary ? classes.elem('aiSummaryPendo').b() : ''}
				justifyContent="flex-start"
				direction="column"
			>
				<div className={classes.elem('hoverableContent').b()}>
					{isLoading ? (
						<Text size="sm">{aboutText}</Text>
					) : showAISummary ? (
						<Tooltip title={t('default.aiGeneratedText')} position="top">
							<Text size="sm">{summary}</Text>
						</Tooltip>
					) : (
						<Text className={classes.elem('aboutText').mod({ expanded }).b()} size="sm">
							{aboutText}
						</Text>
					)}
				</div>
			</Flex>
		</div>
	);
};

export default AboutDropDown;
